import { Button } from 'antd';
import { Navigate } from 'react-router-dom';
import { BE_DOMAIN } from '../../../constants/ApiConstants';

export default function Login() {
  console.log(window.location);

  return (
    <div>
      {window.location.hostname == 'localhost' && (
        <Navigate to="/transactions" />
      )}
      <h1>Login</h1>
      <Button
        onClick={() => {
          window.location.href = BE_DOMAIN + '/saml2/authenticate/azure';
        }}
        type="primary"
      >
        Click here to login
      </Button>
    </div>
  );
}
